import React, {Component} from "react";
import firebase from "firebase";
import {
    MDBDropdown,
    MDBNavbar,
    MDBNavbarBrand,
    MDBDropdownToggle,
    MDBNavbarToggler,
    MDBCollapse,
    MDBDropdownMenu, MDBNavbarNav,
    MDBDropdownItem, MDBNavItem,
    MDBBtn, MDBInputGroup, MDBNavLink, MDBFormInline
} from 'mdbreact';
import classes from './Heading.module.css'
import {
    faArrowLeft, faBars,
    faBell,
    faBookmark, faClipboardList, faFileAlt, faImages, faKey, faLock, faPaperPlane, faSignOutAlt, faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import common from "../../../Utils/common.module.css";

import logo from '../../../Asset/logo.png'
import {isAuth} from "../../../Utils/firebaseUtils";

class Heading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isAdmin: false,
            searchStr: ''
        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (isAuth(nextProps.auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    if (idTokenResult.claims.type === "administrator") {
                        this.setState({
                            isAdmin: true
                        })
                    }
                })
        }
        else{
            this.setState({
                isAdmin: false
            })
        }
    }


    startToSearch = async (e) => {
        e.preventDefault()
        return await new Promise((resolve, reject) => {
            fetch("/api/search/all", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    searchStr: this.state.searchStr
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (searchResult.length !== 0) {
                    console.log(searchResult)
                }
            })
        })
    }

    render() {
        return (
            <div>
                <header>
                    <MDBNavbar className={classes.Heading} dark expand="md" fixed="top">
                        {
                            this.props.location.pathname !== '/' ?
                                <button className={common.HeadingBackBtnFixed}
                                        onClick={(e) => {
                                            this.props.history.goBack()
                                        }}
                                >
                                    <FontAwesomeIcon icon={faArrowLeft}/>

                                </button>
                                :
                                ''
                            // <div  className={classes.NavToggler}>
                            //     <FontAwesomeIcon icon={faBars} className={classes.NavTogglerIcon} onClick={() => this.toggle()} />
                            // </div>

                        }


                        <MDBNavbarBrand className={classes.Branding}>
                            <Link to={{pathname: '/'}}>
                                <img src={logo} alt={'tmingler, 明師鳴，鳴師明'}/>
                            </Link>
                        </MDBNavbarBrand>

                        <MDBCollapse isOpen={this.state.isOpen} navbar className={classes.MobileCollapse}>

                            <MDBNavbarNav left>
                                {
                                    this.props.auth.isEmpty ?
                                        <MDBNavItem className={classes.ButtonItem}>
                                            <MDBNavLink className="waves-effect waves-light"
                                                        to={{pathname: '/login'}}>
                                                {/*<Link to=>*/}
                                                <FontAwesomeIcon icon={faKey} className={classes.Icon}/>
                                                <span className={classes.ButtonItemText}>登入</span>
                                                {/*</Link>*/}
                                            </MDBNavLink>
                                        </MDBNavItem>
                                        :
                                        ''
                                }

                                {
                                    this.state.isAdmin &&
                                    <MDBNavItem className={classes.ButtonItem}>
                                        <MDBNavLink className="waves-effect waves-light"
                                                    to={{pathname: '/admin/portal'}}>

                                            <FontAwesomeIcon icon={faClipboardList} className={classes.Icon}/>
                                            <span className={classes.ButtonItemText}>Portal</span>

                                        </MDBNavLink>
                                    </MDBNavItem>
                                }

                            </MDBNavbarNav>

                            <MDBNavbarNav right>


                                <MDBNavItem className={classes.ButtonItemDropDownList}>

                                    <MDBDropdown className={classes.UserDropDown}>
                                        <MDBDropdownToggle nav className={classes.UserDropDownToggle}>
                                            <FontAwesomeIcon icon={faBell} className={classes.IconRight}/>

                                        </MDBDropdownToggle>
                                        <MDBDropdownMenu className={classes.DropDownNotification}>
                                            Coming
                                        </MDBDropdownMenu>
                                    </MDBDropdown>

                                </MDBNavItem>

                                <MDBNavItem className={classes.ButtonItemDropDownList}>
                                    <MDBDropdown className={classes.UserDropDown}>
                                        <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                                            <FontAwesomeIcon icon={faUserCircle} className={classes.IconRight}/>
                                            <span className={classes.ButtonItemTextRight}>
                                                {
                                                    this.props.auth.isEmpty ?
                                                        "未登入"
                                                        : this.props.auth.displayName
                                                }
                                            </span>
                                        </MDBDropdownToggle>

                                        {
                                            this.props.auth.isEmpty ?
                                                <MDBDropdownMenu className={classes.DropDownMenu}>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/login'}}>登入
                                                        </Link>
                                                    </MDBDropdownItem>
                                                </MDBDropdownMenu>
                                                :
                                                <MDBDropdownMenu className={classes.DropDownMenu}>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/m/profile'}}>我的資料
                                                        </Link>
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/m/collection'}}>我的收藏
                                                        </Link>
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/m/history'}}>我的回覆
                                                        </Link>
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem className={classes.DropDownItem}>
                                                        <Link
                                                            to={{pathname: '/m/post'}}>我的發文
                                                        </Link>
                                                    </MDBDropdownItem>

                                                    <MDBDropdownItem className={classes.DropDownItem}
                                                                     onClick={() => firebase.auth().signOut()}>
                                                        <a>
                                                            登出
                                                        </a>
                                                    </MDBDropdownItem>

                                                </MDBDropdownMenu>
                                        }

                                    </MDBDropdown>
                                </MDBNavItem>
                            </MDBNavbarNav>

                        </MDBCollapse>

                        <MDBDropdown className={common.HeadingBackBtnRightFixedProfile}>
                            <MDBDropdownToggle nav caret className={classes.UserDropDownToggle}>
                                <FontAwesomeIcon icon={faUserCircle} className={classes.IconRight}/>
                            </MDBDropdownToggle>

                            {
                                this.props.auth.isEmpty ?
                                    <MDBDropdownMenu className={classes.DropDownMenu}>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/login'}}>登入
                                            </Link>
                                        </MDBDropdownItem>
                                    </MDBDropdownMenu>
                                    :
                                    <MDBDropdownMenu className={classes.DropDownMenu}>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/m/profile'}}>我的資料
                                            </Link>
                                        </MDBDropdownItem>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/m/collection'}}>我的收藏
                                            </Link>
                                        </MDBDropdownItem>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/m/history'}}>我的回覆
                                            </Link>
                                        </MDBDropdownItem>
                                        <MDBDropdownItem className={classes.DropDownItem}>
                                            <Link
                                                to={{pathname: '/m/post'}}>我的發文
                                            </Link>
                                        </MDBDropdownItem>

                                        <MDBDropdownItem className={classes.DropDownItem}
                                                         onClick={() => firebase.auth().signOut()}>
                                            <a>
                                                登出
                                            </a>
                                        </MDBDropdownItem>

                                    </MDBDropdownMenu>
                            }

                        </MDBDropdown>
                    </MDBNavbar>
                </header>
            </div>

        )
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)


export default enhance(withRouter(Heading))